module.exports = __webpack_public_path__ + "static/media/Weight-1.ef0f3db8.png";